import {Component, signal, ChangeDetectionStrategy} from "@angular/core"
import {BaseInspectorComponent} from "@app/template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@app/template-editor/components/inspectors/inspector-section/inspector-section.component"
import {SelectionPossibilities, ValueSlotComponent} from "@app/template-editor/components/value-slot/value-slot.component"
import {BlendMaterialSlot, BlendMaterialSlotParameters, TransformMaterialSlotType} from "@cm/template-nodes"

export const transformMaterialSlotTypeSelectionPossibilities: SelectionPossibilities<TransformMaterialSlotType> = [
    {value: TransformMaterialSlotType.BaseColor, name: "Base Color"},
    {value: TransformMaterialSlotType.Metallic, name: "Metallic"},
    {value: TransformMaterialSlotType.Specular, name: "Specular"},
    {value: TransformMaterialSlotType.Roughness, name: "Roughness"},
    {value: TransformMaterialSlotType.Anisotropic, name: "Anisotropic"},
    {value: TransformMaterialSlotType.AnisotropicRotation, name: "Anisotropic Rotation"},
    {value: TransformMaterialSlotType.Alpha, name: "Alpha"},
    {value: TransformMaterialSlotType.Normal, name: "Normal"},
    {value: TransformMaterialSlotType.Sheen, name: "Sheen"},
    {value: TransformMaterialSlotType.SheenTint, name: "Sheen Tint"},
    {value: TransformMaterialSlotType.Clearcoat, name: "Clearcoat"},
    {value: TransformMaterialSlotType.ClearcoatRoughness, name: "Clearcoat Roughness"},
    {value: TransformMaterialSlotType.Transmission, name: "Transmission"},
    {value: TransformMaterialSlotType.Emission, name: "Emission"},
]

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-blend-material-slot-inspector",
    templateUrl: "./blend-material-slot-inspector.component.html",
    styleUrl: "./blend-material-slot-inspector.component.scss",
    imports: [InspectorSectionComponent, ValueSlotComponent],
})
export class BlendMaterialSlotInspectorComponent extends BaseInspectorComponent<BlendMaterialSlot, {}> {
    readonly $slotPossibilities = signal<SelectionPossibilities<BlendMaterialSlotParameters["slot"]>>(transformMaterialSlotTypeSelectionPossibilities)
}
